import { jsx as r } from "react/jsx-runtime";
function o() {
  return /* @__PURE__ */ r(
    "div",
    {
      className: "border-2 h-5 w-5 border-t-white border-gray-200/50 rounded-full animate-spin"
    }
  );
}
export {
  o as WhiteLoadingIndicator
};
//# sourceMappingURL=WhiteLoadingIndicator.js.map
